import { isAppStateReady } from '$appStore'
import { logger } from '$utils'
import { defer, LoaderFunctionArgs } from 'react-router-dom'
import useStockStore from 'src/components/routes/stock/store'

export default async function loader(loaderFunctionArgs: LoaderFunctionArgs) {
  logger.debug(
    '[loader] About to await AppState being ready in Order Templates loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in Order Templates loader'
  )

  useStockStore.getState().resetOrderTemplateSlice()
  useStockStore.getState().resetEditOrderTemplatesSlice()

  const items = useStockStore.getState().getItems()

  const brands = useStockStore.getState().getBrands()

  const suppliers = useStockStore.getState().getSuppliers()

  const units = useStockStore.getState().getStockUnits()

  const subcategories = useStockStore.getState().getSubcategories()

  const salesTax = useStockStore.getState().getSalesTax()

  const orderTemplatePromise = useStockStore
    .getState()
    .initializeOrderTemplateData(loaderFunctionArgs)

  // Return a deferred promise to enable React Router's built-in loading state
  return defer({
    data: Promise.all([
      items,
      brands,
      suppliers,
      units,
      subcategories,
      salesTax,
      orderTemplatePromise,
    ])
      .then(() => true)
      .catch((error) => {
        logger.error('Loader Order Templates error: ', error)
        return false
      }),
  })
}
